import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';

// 顶部进度条
Vue.use(VueProgressBar, {
	color: '#3498db',
	failedColor: '#e74c3c',
	thickness: '2px',
	location: 'top',
});